// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","btnPrimary":"Button_btnPrimary__T3e5e"};